export default "__VITE_ASSET__IqyW5mGR__"